import React, { useContext } from "react"
import { Helmet } from "react-helmet"
import favicon from "./../assets/images/favicon.png"
import LocaleContext from "../context/Locale"

const Seo = ({ seo }) => {
  const ogImage = seo?.ogImage?.data?.attributes?.url

  const siteUrl = "https://rentalls.com/sk/"
  const defaultSeo = {
    title: "defaultTitle",
    description: "defaultDescription",
    image: `${siteUrl}${favicon}`,
    url: siteUrl,
    shareImage: `https://cms.rentalls.com${ogImage}`,
  }

  const { activeLocale } = useContext(LocaleContext)

  // Merge default and page-specific SEO values
  const fullSeo = {
    ...defaultSeo,
    ...seo,
  }

  const metaTags = [
    // Title and description
    {
      name: "title",
      content: fullSeo.metaTitle,
    },
    {
      name: "description",
      content: fullSeo.metaDescription,
    },

    // Open Graph meta tags
    {
      property: "og:url",
      content: fullSeo.url || siteUrl,
    },
    {
      property: "og:type",
      content: fullSeo.article ? "article" : "website",
    },
    {
      property: "og:title",
      content: fullSeo.metaTitle,
    },
    {
      property: "og:description",
      content: fullSeo.metaDescription,
    },
    {
      property: "og:image",
      content: ogImage ? fullSeo?.shareImage : fullSeo.image,
    },

    // Twitter meta tags
    {
      name: "twitter:card",
      content: "summary_large_image",
    },
    {
      name: "twitter:title",
      content: fullSeo.metaTitle,
    },
    {
      name: "twitter:description",
      content: fullSeo.metaDescription,
    },
    {
      name: "twitter:site",
      content: "@rentalls",
    },
    {
      name: "twitter:image",
      content: ogImage ? fullSeo?.shareImage : fullSeo.image,
    },
  ]

  const scriptTags = [
    {
      type: "text/javascript",
      innerHTML: `
        window.smartlook||(function(d) {
          var o=smartlook=function(){ o.api.push(arguments)},h=d.getElementsByTagName('head')[0];
          var c=d.createElement('script');o.api=new Array();c.async=true;c.type='text/javascript';
          c.charset='utf-8';c.src='https://web-sdk.smartlook.com/recorder.js';h.appendChild(c);
        })(document);
        smartlook('init', '4a7152b00fc9ca046de95d3427102350725b0161', { region: 'eu' });
      `,
    },
  ]

  if (activeLocale === "en") {
    scriptTags.push({
      type: "text/javascript",
      innerHTML: `
        window.tolstoyAppKey="4a227113-a393-4944-96f6-65c04fde58ce"; 
        var s = document.createElement("script"); 
        s.type = "text/javascript"; 
        s.async = true; 
        s.src = "https://widget.gotolstoy.com/widget/widget.js"; 
        document.head.appendChild(s);
      `,
    })
  } else {
    scriptTags.push({
      type: "text/javascript",
      innerHTML: `
        window.tolstoyAppKey="4a227113-a393-4944-96f6-65c04fde58ce"; 
        var s = document.createElement("script"); 
        s.type = "text/javascript"; 
        s.async = true; 
        s.src = "https://widget.gotolstoy.com/widget/widget.js"; 
        document.head.appendChild(s);
      `,
    })
  }

  return (
    <Helmet
      title={fullSeo.metaTitle}
      meta={metaTags}
      script={scriptTags}
      link={[
        {
          rel: "icon",
          type: "image/png",
          href: favicon,
        },
        {
          href: "https://assets.calendly.com/assets/external/widget.css",
          rel: "stylesheet",
        },
        {
          href: fullSeo.url || "https://rentalls.com/sk/blog/",
          rel: "canonical",
        },
      ]}
    >
      <script
        src="https://assets.calendly.com/assets/external/widget.js"
        type="text/javascript"
        async
      ></script>
      <script src="https://kit.fontawesome.com/391f644c42.js"></script>
    </Helmet>
  )
}

export default Seo
